import * as rescuedFoodActions from '../actions/rescuedFood';

export const initialSitesState = {
  inflight: false,
  all: [],
  lastUpdated: null,
};

const rescuedFoodReducer = (state = initialSitesState, action) => {
  switch (action.type) {
    case rescuedFoodActions.REQUEST_RESCUED_FOOD:
      return {
        ...state,
        inflight: true,
      };
    case rescuedFoodActions.RECEIVE_RESCUED_FOOD:
      return {
        ...state,
        inflight: false,
        all: action.rescuedFood,
        lastUpdated: action.receivedAt,
      };
    default:
      return state;
  }
};

export default rescuedFoodReducer;
